export const CLAIM_ALL_DIALOG_SHOW = 'CLAIM_ALL_DIALOG_SHOW';
export const CLAIM_ALL_DIALOG_HIDE = 'CLAIM_ALL_DIALOG_HIDE';

export const ALL_CLAIMABLE_STREAMS_SUCCESS = 'ALL_CLAIMABLE_STREAMS_SUCCESS';
export const ALL_CLAIMABLE_STREAMS_IN_PROGRESS = 'ALL_CLAIMABLE_STREAMS_IN_PROGRESS';
export const ALL_CLAIMABLE_STREAMS_ERROR = 'ALL_CLAIMABLE_STREAMS_ERROR';
